import script from "./OrganisationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganisationSettings.vue?vue&type=script&setup=true&lang=js"

import "./OrganisationSettings.vue?vue&type=style&index=0&id=4e2f5e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2f5e5e"]])

export default __exports__